(function() {
	'use strict';

	angular.module('returnLetterApp').controller(
			'ReturnLetterViewDetailController', ReturnLetterViewDetailController);

	ReturnLetterViewDetailController.$inject = [ '$scope', 'ReturnLetterService', '$location',
			'RETURN_LETTER', 'CommonService', '$window', 'Upload',
			'authExpiredInterceptor', '$log', '$base64', '$stateParams' ];

	function ReturnLetterViewDetailController($scope, ReturnLetterService, $location, RETURN_LETTER,
			CommonService, $window, Upload, authExpiredInterceptor, $log,
			$base64, $stateParams) {
		var detailViewCtr = this;
		var param = $stateParams;
		detailViewCtr.processResults = RETURN_LETTER.PROCESS_RESULTS;
		detailViewCtr.lstNationality = CommonService.query({
			masterurl : 'nationality'
		});
		detailViewCtr.download = function() {
			//danh cho ie
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for IE browser
				if (detailViewCtr.returnLetter.archiveData.dataContent != undefined) {
					var byteCharacters = atob(detailViewCtr.returnLetter.archiveData.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : detailViewCtr.returnLetter.archiveData.type + ';charset=utf-8'
					});
					window.navigator
							.msSaveBlob(blob, detailViewCtr.returnLetter.archiveData.dataName);
				} else {
					var blob = new Blob([ detailViewCtr.returnLetter.archiveData ], {
						type : detailViewCtr.returnLetter.archiveData.type + ';charset=utf-8'
					});
					window.navigator
							.msSaveBlob(blob, detailViewCtr.returnLetter.archiveData.dataName);
				}
			} else {
				//truong hop file da luu duoi database
				if (detailViewCtr.returnLetter.archiveData.content != undefined) {
					var byteCharacters = atob(detailViewCtr.returnLetter.archiveData.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : detailViewCtr.returnLetter.archiveData.type + ';charset=utf-8'
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = detailViewCtr.returnLetter.archiveData.dataName;
					aTag.click();
				} else {
					//truong hop file luu tam tren man hinh
					var blob = new Blob([ detailViewCtr.returnLetter.archiveData ], {
						type : detailViewCtr.returnLetter.archiveData.type + ';charset=utf-8'
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = detailViewCtr.returnLetter.archiveData.dataName;
					aTag.click();
				}
			}
		};
		//check paramester 
		 if (param.txnId != undefined && param.txnId != '') {
			 $scope.loading= true;
			 var txnId = $base64.decode(param.txnId)
			 //get policy info
			 ReturnLetterService.get({uri : 'get-return-letter-view-detail',txnId : txnId
				},function(result) {
					$scope.loading= false;
					detailViewCtr.returnLetter = result;
					detailViewCtr.returnLetter.country = 'VN';
					detailViewCtr.returnLetter.mobileCode = "84";
					detailViewCtr.returnLetter.homeCode = "84";
					detailViewCtr.returnLetter.compCode = "84";
			 }, function(error){
				 $scope.loading= false;
			 });
		};
		
		/**
		 * View letter
		 */
		detailViewCtr.viewReport = function() {
        	if(detailViewCtr.returnLetter.transaction.txnId != null && detailViewCtr.returnLetter.transaction.txnId != undefined){
        		var txnId = detailViewCtr.returnLetter.transaction.txnId;
        		window.open(GLOBAL_URL+'api/ga/return-letter/view-report-address/'+txnId+'?access_token=' + authExpiredInterceptor.getToken(),'_blank');
        	}
        	
        };
        
        /**
         * print confirm letter
         */
        detailViewCtr.printAddress = function() {
        	if(detailViewCtr.returnLetter.transaction.txnId != null && detailViewCtr.returnLetter.transaction.txnId != undefined ){
        		 $scope.loading=true;
        		 ReturnLetterService.download({uri:'print-letter-address'}, detailViewCtr.returnLetter, function(result){
        			 $scope.loading=false;
        			 if(result){
        				 detailViewCtr.returnLetter.letterStatus = 'SUCCESS';
        				 $scope.addAlert('In thư xác nhận thành công.','success');
        			 }
        		 },
        		 function(error) {
        			 $scope.loading= false;
        			 $scope.addAlert('Có lỗi hệ thống. Vui lòng kiểm tra lại.','danger');
        		 });
        	}
        };
	}
})();
